:host {
  @apply block cursor-pointer;
}

a {
  @apply relative text-center text-grey;

  &.disabled {
    @apply pointer-events-none;
  }

  &:hover,
  &.active {
    @apply text-berry transition-colors;

    font-weight: bold;

    // Target Safari 10+
    @media not all and (min-resolution:.001dpcm) {
      letter-spacing: -1px;
    }
  }

  &:not(.no-decoration):hover:after {
    @apply w-full;
  }

  &:not(.no-decoration):after {
      content: '';
      position: absolute;
      height: 1px;
      background: var(--vt-color-berry-default, #D7004B);;
      bottom: 0;
      left: 50%;
      width: 0;
      transition: width 0.25s linear;
      transform: translateX(-50%);
  }
}

::slotted(span.uk-icon) {
  @apply relative top-[3px] pointer-events-none;
}
